import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { GetStudentDataForGroupPayload } from "../../payload/GetStudentDataForGroup/GetStudentDataForGroupPayload";

const getStudentDataForGroupFetch = (state: GroupsState, action: PayloadAction<GetStudentDataForGroupPayload>) => {
    state.isLoading = true
}

export default getStudentDataForGroupFetch;